const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for adding and updating multiple users at a time
 * @argument {Application} Application defines the Application service
 * @argument {$q} $q defines the $q service
 * @argument {Categories} Categories defines the Categories resource
 */
app.factory('AssessmentLib', ['Application', 'Authorization', function (Application) {

  var helpers = {
    getQuestionOptions: function(question) {
      var opts = {};
      if (!question || !question.question_options || !question.question_options.length) {
        return opts;
      }
      question.question_options.forEach(function(item) {
        if (!item.name) {
          return;
        }
        opts[item.name] = item.value;
      });
      return opts;
    },
    // This algorithm needs to match the behavior in the AssessmentScoresManager of the api
    // Changes here need reflected there and vice versa
    getQuestionValue: function(question) {
      var points = 0;

      if (question.rubric_grading) {
        if (question.rubric_options && question.rubric_options.length) {
          question.rubric_options.forEach(function(option) {
            if (option && option.points) {
              points += option.points;
            }
          });
        }
        return points;
      }

      if (!question) {
        return points;
      }

      var options = helpers.getQuestionOptions(question);

      if (options.manual_grade || options.question_value_is_custom) {
        return options.manual_points || points;
      }

      if (!question.choice_options || !question.choice_options.length) {
        return points;
      }

      for (var i = 0; i < question.choice_options.length; i++) {
        if (!question.choice_options[i] || !question.choice_options[i].points) {
          continue;
        }
        if (options.max_value_is_total) {
          points += question.choice_options[i].points;
          continue;
        }
        if (points < question.choice_options[i].points) {
          points = question.choice_options[i].points;
        }
      }

      return points;
    },
    isAnswered: function(question, answerArray) {
      if (!answerArray || !answerArray.length) {
        return false;
      }
      var actualAnswerLength = 0;
      answerArray.forEach(function(item) {
        if (item) {
          actualAnswerLength++;
        }
      })
      var options = helpers.getQuestionOptions(question);
      var count = 1;
      if (!options.manual_grade && options.multiple_selections && options.number_of_selections) {
        count = options.number_of_selections;
      }

      if (question.format === 'long_input') {
        var max = options.word_limit || 5000;
        var min = options.word_minimum || 1;
        var wordCount = 0;
        var answer = answerArray[0];

        if (answer && typeof answer === 'string') {
          wordCount = answer.split(' ').length;
        }

        if (wordCount > max) {
          return;
        }

        if (wordCount < min) {
          return;
        }
      }

      return actualAnswerLength >= count;
    },
    makeId: function () {
      var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
      return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
          return (Math.random() * 16 | 0).toString(16);
      }).toLowerCase();
    }
  };

  return {
    helpers: helpers
  };
}]);